/* ============================================================
   CHANNEL COMPONENTS — registry for `kind: 'component'` channels.
   A channel can render a custom React component instead of playing
   YouTube (an interactive channel). Mirrors the bump registry: a key
   → a lazily-imported component, so the code only loads when tuned.
   ============================================================ */
import { lazy, type ComponentType } from 'react'

const REGISTRY: Record<string, ComponentType> = {
  'hideo-mgs': lazy(() => import('./HideoMgs')),
}

/** The component for a channel's `component` key, or null if unknown/none. */
export function channelComponent(key: string | null | undefined): ComponentType | null {
  return key ? REGISTRY[key] ?? null : null
}
